import { isTagType } from "src/util/tagType";
import { getAllParentTagIds } from "src/commonComponents/TagProfileHeader/utils/tagUtils";

type TagLike = {
  id: string;
  type?: string | undefined;
  attributes?: Record<string, string | undefined> | undefined;
};

export const isActiveInTagTypeSection = (
  activeTagId: string | undefined,
  tagTypeId: string,
  tagTypesConfig: Record<string, unknown>,
  activeTag?: TagLike | null
): boolean => {
  if (!activeTagId) {
    return false;
  }

  if (isTagType(tagTypesConfig, activeTagId)) {
    return activeTagId === tagTypeId;
  }

  return activeTag?.type === tagTypeId;
};

export const buildTagExpandPathIds = (
  tagTypeId: string,
  activeTagId: string,
  tagTypesConfig: Record<string, unknown>,
  ancestorIds: string[]
): string[] => {
  if (isTagType(tagTypesConfig, activeTagId)) {
    return [tagTypeId];
  }

  return [tagTypeId, ...ancestorIds];
};

export const getImmediateParentTagIds = (
  tag: TagLike | null | undefined,
  tagTypesConfig: Record<string, unknown>
): string[] => getAllParentTagIds(tag, tagTypesConfig);
